const lang = {
  menu: {
    'Danh mục mua sắm': 'Danh mục mua sắm',
    'Dành cho đối tác': 'Dành cho đối tác',
    Developers: 'Developers',
    'Về Fundiin': 'Về Fundiin',
    privacy: 'Privacy',
    deleteAccount: 'Delete account',
  },
  'Đăng ký ngay': 'Đăng ký ngay',
  hero: {
    solution: 'Giải Pháp<1/>Mua Trước - Trả Sau<1/>Phổ Biến Nhất Việt Nam',
    partner: 'Hợp tác cùng Fundiin<1/>Tăng đến 30%<1/>doanh thu',
    free: 'Tự do tài chính <1/>Sống hạnh phúc hơn',
  },
  different: {
    'Điều gì làm Fundiin khác biệt?': 'Điều gì làm Fundiin khác biệt?',
    'Không lo Lãi suất': 'Không lo Lãi suất',
    '0% lãi suất cho mọi kỳ hạn': '0% lãi suất cho mọi kỳ hạn',
    'Không bắt buộc tải app': 'Không bắt buộc tải app',
    'Nhắc nhở thanh toán tự động qua điện thoại.':
      'Nhắc nhở thanh toán tự động qua điện thoại.',
    'Phí minh bạch': 'Phí minh bạch',
    'Xóa tan mọi lo lắng với chính sách phí minh bạch dễ hiểu, không phí ẩn.':
      'Xóa tan mọi lo lắng với chính sách phí minh bạch dễ hiểu, không phí ẩn.',
    'Xét duyệt chỉ 5 giây': 'Xét duyệt chỉ 5 giây',
    'Nói không với thủ tục phức tạp, duyệt tài khoản nhanh chóng với CCCD và hình chân dung.':
      'Nói không với thủ tục phức tạp, duyệt tài khoản nhanh chóng với CCCD và hình chân dung.',
  },
  together: {
    'Cùng Fundiin Tăng Trưởng Vượt Trội!':
      'Cùng Fundiin Tăng Trưởng Vượt Trội!',
    'Tăng doanh thu đến 30%': 'Tăng doanh thu đến 30%',
    'Tăng tỉ lệ chốt đơn và trải nghiệm khách hàng tại điểm bán với giải pháp tài chính thông minh.':
      'Tăng tỉ lệ chốt đơn và trải nghiệm khách hàng tại điểm bán với giải pháp tài chính thông minh.',
    'Tăng giá trị đơn hàng trung bình đến 1.8 lần':
      'Tăng giá trị đơn hàng trung bình đến 1.8 lần',
    'Thúc đẩy tăng giá trị đơn hàng (AOV) gấp 1.8 lần so với ví điện tử.':
      'Thúc đẩy tăng giá trị đơn hàng (AOV) gấp 1.8 lần so với ví điện tử.',
    'Tối ưu hoá dòng tiền kinh doanh': 'Tối ưu hoá dòng tiền kinh doanh',
    'Nhận toàn bộ giá trị đơn hàng từ Fundiin, tiết kiệm chi phí thúc đẩy bán hàng cho doanh nghiệp.':
      'Nhận toàn bộ giá trị đơn hàng từ Fundiin, tiết kiệm chi phí thúc đẩy bán hàng cho doanh nghiệp.',
    'Hỗ trợ quảng bá thương hiệu': 'Hỗ trợ quảng bá thương hiệu',
    'Hợp tác tăng cường nhận diện sản phẩm & thương hiệu, giúp đối tác tiếp cận khách hàng tiềm năng.':
      'Hợp tác tăng cường nhận diện sản phẩm & thương hiệu, giúp đối tác tiếp cận khách hàng tiềm năng.',
  },
  solution: {
    'Giải Pháp Thanh Toán': 'Giải Pháp Thanh Toán',
    'Trả sau miễn phí': 'Trả sau miễn phí',
    'Giải pháp chia nhỏ thanh toán Miễn phí - Miễn lãi':
      'Giải pháp chia nhỏ thanh toán Miễn phí - Miễn lãi',
    'Trả sau 14 ngày hoặc Chia 2 kỳ thanh toán':
      'Trả sau 14 ngày hoặc Chia 2 kỳ thanh toán',
    'Hoàn toàn 0% phí - 0% lãi': 'Hoàn toàn 0% phí - 0% lãi',
    'Áp dụng cho đơn hàng từ 0đ': 'Áp dụng cho đơn hàng từ 0đ',
    'Trả sau linh hoạt': 'Trả sau linh hoạt',
    'BNPL+ Trả sau lên đến 12 tháng': 'BNPL+ Trả sau lên đến 12 tháng',
    'Giải pháp chia nhỏ thanh toán thành 3-6-9-12 kỳ.':
      'Giải pháp chia nhỏ thanh toán thành 3-6-9-12 kỳ.',
    'Trả trước từ 30% giá trị đơn hàng': 'Trả trước từ 30% giá trị đơn hàng',
    '0% lãi suất cho mọi kỳ hạn': '0% lãi suất cho mọi kỳ hạn',
    'Phí dịch vụ hấp dẫn chỉ từ 0.8% - 2.6%́ trên dư nợ gốc':
      'Phí dịch vụ hấp dẫn chỉ từ 0.8% - 2.6%́ trên dư nợ gốc',
  },
  direction: {
    'Hướng dẫn thanh toán': 'Hướng dẫn thanh toán',
    'Hướng dẫn mua hàng': 'Hướng dẫn mua hàng',
    'Thanh toán các kỳ': 'Thanh toán các kỳ',
    tabs1: {
      'Mua hàng': 'Mua hàng',
      'Mua sắm tại các thương hiệu thuộc danh mục mua sắm của Fundiin và chọn Fundiin làm phương thức thanh toán':
        'Mua sắm tại các thương hiệu thuộc danh mục mua sắm của Fundiin và chọn Fundiin làm phương thức thanh toán',
      'Chọn Fundiin để thanh toán': 'Chọn Fundiin để thanh toán',
      'Tiến hành đăng ký tài khoản nếu là lần đầu thanh toán qua Fundiin. Ngoài ra, bạn có thể đăng ký tài khoản trước bằng cách tải ứng dụng App Store hoặc Google Play Store.':
        'Tiến hành đăng ký tài khoản nếu là lần đầu thanh toán qua Fundiin. Ngoài ra, bạn có thể đăng ký tài khoản trước bằng cách tải ứng dụng App Store hoặc Google Play Store.',
      'Điều kiện thanh toán trả sau với Fundiin':
        'Điều kiện thanh toán trả sau với Fundiin',
      'Là công dân Việt Nam trong độ tuổi ở từ 18 tuổi trở lên':
        'Là công dân Việt Nam trong độ tuổi ở từ 18 tuổi trở lên',
      'Sở hữu Chứng minh thư hoặc CCCD bản gốc và đang còn hiệu lực':
        'Sở hữu Chứng minh thư hoặc CCCD bản gốc và đang còn hiệu lực',
      'Định danh tài khoản': 'Định danh tài khoản',
      'Đăng ký tài khoản': 'Đăng ký tài khoản',
      'Nhập số điện thoại chính chủ từ các nhà mạng Viettel, Mobifone, Vinaphone, thiết lập mật khẩu gồm 6 chữ số. Sau đó bấm "Tiếp tục".':
        'Nhập số điện thoại chính chủ từ các nhà mạng Viettel, Mobifone, Vinaphone, thiết lập mật khẩu gồm 6 chữ số. Sau đó bấm "Tiếp tục".',
      'Xác thực tài khoản với 2 mặt Chứng minh thư và một hình selfie gương mặt':
        'Xác thực tài khoản với 2 mặt Chứng minh thư và một hình selfie gương mặt',
      'Kích hoạt tài khoản': 'Kích hoạt tài khoản',
      'Nhận kết quả kích hoạt tài khoản thành công':
        'Nhận kết quả kích hoạt tài khoản thành công',
      'Thanh toán kỳ 1': 'Thanh toán kỳ 1',
      'Kiểm tra thông tin': 'Kiểm tra thông tin',
      'Kiểm tra tổng số tiền thanh toán và thêm mã giảm giá (nếu có)':
        'Kiểm tra tổng số tiền thanh toán và thêm mã giảm giá (nếu có)',
      'Chọn lịch thanh toán': 'Chọn lịch thanh toán',
      'Chọn lịch thanh toán phù hợp với nhu cầu.':
        'Chọn lịch thanh toán phù hợp với nhu cầu.',
      'Chọn phương thức thanh toán': 'Chọn phương thức thanh toán',
      'Chọn phương thức thanh toán phù hợp và làm theo hướng dẫn của phương thức đã chọn':
        'Chọn phương thức thanh toán phù hợp và làm theo hướng dẫn của phương thức đã chọn',
    },
    tabs2: {
      'Tải ứng dụng Fundiin': 'Tải ứng dụng Fundiin',
      'Tải ứng dụng với từ khóa “Fundiin” trên App Store hoặc Google Play Store và thực hiện đăng nhập vào ứng dụng.':
        'Tải ứng dụng với từ khóa “Fundiin” trên App Store hoặc Google Play Store và thực hiện đăng nhập vào ứng dụng.',
      'Chọn hoá đơn thanh toán': 'Chọn hoá đơn thanh toán',
      'Vào mục “Hóa đơn”, chọn đơn hàng cần thanh toán và bấm “Thanh toán”':
        'Vào mục “Hóa đơn”, chọn đơn hàng cần thanh toán và bấm “Thanh toán”',
      'Chọn phương thức thanh toán': 'Chọn phương thức thanh toán',
      'Chọn phương thức thanh toán phù hợp và làm theo hướng dẫn của phương thức đã chọn':
        'Chọn phương thức thanh toán phù hợp và làm theo hướng dẫn của phương thức đã chọn',
    },
  },
  dowloadApp: {
    title: 'Trải nghiệm liền mạch hơn trên App',
    subTitle:
      'Khám phá vô vàn ưu đãi. Cập nhật các thương hiệu mới nhất. Thanh toán dễ dàng hơn trên app Fundiin ngay hôm nay!',
    'Quét mã để tải ứng dụng': 'Quét mã để tải ứng dụng',
  },
  footer: {
    'Công ty cổ phần Fundiin': 'Công ty cổ phần Fundiin',
    'Tầng 7, Tòa Nhà Lottery, số 77, đường Trần Nhân Tôn, Phường 09, Quận 5, TP. Hồ Chí Minh, Việt Nam':
      'Tầng 7, Tòa Nhà Lottery, số 77, đường Trần Nhân Tôn, Phường 09, Quận 5, TP. Hồ Chí Minh, Việt Nam',
    'Giới thiệu': 'Giới thiệu',
    'Sản phẩm': 'Sản phẩm',
    'Về Fundiin': 'Về Fundiin',
    'Danh mục mua sắm': 'Danh mục mua sắm',
    'Đối tác': 'Đối tác',
    'Dành cho đối tác': 'Dành cho đối tác',
    'Chính sách & Điều khoản': 'Chính sách & Điều khoản',
    'Điều khoản mua hàng': 'Điều khoản mua hàng',
    'Chính sách quyền riêng tư': 'Chính sách quyền riêng tư',
    'Hợp đồng nguyên tắc': 'Hợp đồng nguyên tắc',
    'Giấy phép kinh doanh số 0315563775 do Sở KHĐT Tp.HCM cấp ngày 14/03/2019':
      'Giấy phép kinh doanh số 0315563775 do Sở KHĐT Tp.HCM cấp ngày 14/03/2019',
  },
  integration: {
    'Đa dạng tích hợp thanh toán': 'Đa dạng tích hợp thanh toán',
    'Fundiin hỗ trợ quy trình tích hợp nhanh chóng với đa dạng loại cửa hàng kinh doanh, website tự xây dựng, hoặc website cung cấp thông qua các nền tảng bán hàng đa kênh':
      'Fundiin hỗ trợ quy trình tích hợp nhanh chóng với đa dạng loại cửa hàng kinh doanh, website tự xây dựng, hoặc website cung cấp thông qua các nền tảng bán hàng đa kênh',
  },
  'Case Study': 'Case Study',
  register: {
    'Đăng ký trở thành đối tác của Fundiin':
      'Đăng ký trở thành đối tác của Fundiin',
    'Để lại thông tin và tìm hiểu cơ hội hợp tác cùng chúng tôi ngay hôm nay!':
      'Để lại thông tin và tìm hiểu cơ hội hợp tác cùng chúng tôi ngay hôm nay!',
    'Tên doanh nghiệp': 'Tên doanh nghiệp',
    'Nhập tên doanh nghiệp': 'Nhập tên doanh nghiệp',
    'Ngành hàng': 'Ngành hàng',
    'Chọn ngành hàng': 'Chọn ngành hàng',
    'Số điện thoại liên hệ': 'Số điện thoại liên hệ',
    'Nhập số điện thoại': 'Nhập số điện thoại',
    'Tên người liên hệ': 'Tên người liên hệ',
    'Nhập họ và tên': 'Nhập họ và tên',
    Email: 'Email',
    'Nhập email': 'Nhập email',
    website: 'Website/Facebook Doanh nghiệp',
    websitePlaceholder: 'Nhập Website/Facebook Doanh nghiệp',
    Gửi: 'Gửi',
  },
  'Khám phá ưu đãi từ các thương hiệu': 'Khám phá ưu đãi từ các thương hiệu',
  category: {
    'Danh mục': 'Danh mục',
    'Hot Brands': 'Hot Brands',
    'Sức khoẻ & làm đẹp': 'Sức khoẻ & làm đẹp',
    'Thời trang nữ': 'Thời trang nữ',
    'Thời trang nam': 'Thời trang nam',
    'Phụ kiện thời trang': 'Phụ kiện thời trang',
    'Nhà cửa Đời sống': 'Nhà cửa Đời sống',
    'Giáo dục': 'Giáo dục',
    'Thể thao du lịch': 'Thể thao du lịch',
    'Mẹ & Bé': 'Mẹ & Bé',
    Khác: 'Khác',
    'Mua hàng': 'Mua hàng',
    Online: 'Online',
    'Tại quầy': 'Tại quầy',
    'Kết quả': 'Kết quả',
  },
  'Áp dụng': 'Áp dụng',
  'Bớt lo toan - sống trọn vẹn': 'Bớt lo toan - sống trọn vẹn',
  'Chúng tôi tin rằng tự do tài chính không chỉ đơn thuần là trở nên giàu có, mà còn là giảm bớt những băn khoăn và áp lực tài chính, để bạn có thêm nhiều thời gian cho những điều thực sự quan trọng trong cuộc sống.':
    'Chúng tôi tin rằng tự do tài chính không chỉ đơn thuần là trở nên giàu có, mà còn là giảm bớt những băn khoăn và áp lực tài chính, để bạn có thêm nhiều thời gian cho những điều thực sự quan trọng trong cuộc sống.',
  'Hãy gác lại những lo lắng về dịch vụ tài chính và để Fundiin giúp bạn tận hưởng cuộc sống một cách trọn vẹn nhất!':
    'Hãy gác lại những lo lắng về dịch vụ tài chính và để Fundiin giúp bạn tận hưởng cuộc sống một cách trọn vẹn nhất!',
  'Tầm nhìn - Sứ mệnh': 'Tầm nhìn - Sứ mệnh',
  'Sứ mệnh của Fundiin là thúc đẩy tự do tài chính vì một cuộc sống tốt đẹp hơn cho tất cả mọi người.':
    'Sứ mệnh của Fundiin là thúc đẩy tự do tài chính vì một cuộc sống tốt đẹp hơn cho tất cả mọi người.',
  'Chúng tôi mong muốn trở thành người bạn đồng hành giúp bạn giải quyết các vấn đề tài chính hàng ngày một cách hiệu quả,  theo đuổi mục tiêu trở thành giải pháp Tài chính được yêu thích hàng đầu tại Đông Nam Á.':
    'Chúng tôi mong muốn trở thành người bạn đồng hành giúp bạn giải quyết các vấn đề tài chính hàng ngày một cách hiệu quả,  theo đuổi mục tiêu trở thành giải pháp Tài chính được yêu thích hàng đầu tại Đông Nam Á.',
  'Giá trị cốt lõi': 'Giá trị cốt lõi',
  'Tại Fundiin, chúng tôi cung cấp một giải pháp tài chính toàn diện, giúp người dùng quản lý và cân đối tài chính một cách hiệu quả. Fundiin cam kết mang đến những giải pháp có lợi cho cả người dùng, đối tác và cộng đồng.':
    'Tại Fundiin, chúng tôi cung cấp một giải pháp tài chính toàn diện, giúp người dùng quản lý và cân đối tài chính một cách hiệu quả. Fundiin cam kết mang đến những giải pháp có lợi cho cả người dùng, đối tác và cộng đồng.',
  'Báo chí nói gì về Fundiin': 'Báo chí nói gì về Fundiin',
  'Nhà đầu tư của Fundiin': 'Nhà đầu tư của Fundiin',
  Bước: 'Bước',
  'Sai định dạng': 'Sai định dạng',
  errorMessage: {
    required: 'Vui lòng điền thông tin',
    invalidPhone: 'Số điện thoại không hợp lệ',
    invalidEmail: 'Email không hợp lệ',
    invalidLink: 'Đường dẫn không hợp lệ',
  },
};

export default lang;
